<template>
    <div :class="inputGroupClass">
        <pre v-if="debug" class="debug__data">
name: {{ inputgroup.name }}
desc: {{ inputgroup.description }}
builder_desc: {{ inputgroup.builder_desc }}
type: {{ inputgroup.inputgroup_category_id == 1 ? "Obligatorisk" : "Valgfritt" }}
id: {{ inputgroup.id }}
        </pre>

        <div v-if="inputgroup.name_visible || inputgroup.description_visible">
            <h2 class="form__inputgroup-headline" v-if="inputgroup.name_visible">{{ inputgroup.name }}</h2>
            <p class="form__inputgroup-description" v-if="inputgroup.description_visible">{{ inputgroup.description }}</p>
        </div>

        <div class="form__inputfield" v-for="inputData in inputgroup.inputs.sort((a, b) => a.order - b.order)"
            :key="inputData.type_id">
            <text-input             v-if="Number(inputData.type_id) === 0"  :inputData="inputData" @inputValue="updateInputValue"></text-input>
            <textarea-input         v-if="Number(inputData.type_id) === 1"  :inputData="inputData" @inputValue="updateInputValue"></textarea-input>
            <number-input           v-if="Number(inputData.type_id) === 2"  :inputData="inputData" @inputValue="updateInputValue"></number-input>
            <select-input           v-if="Number(inputData.type_id) === 3"  :inputData="inputData" :selectedOptions="selectedOptions" @inputOptions="updateInputOptions"></select-input>
            <radio-input            v-if="Number(inputData.type_id) === 4"  :inputData="inputData" :selectedOptions="selectedOptions" @inputOptions="updateInputOptions"></radio-input>
            <checkbox-input         v-if="Number(inputData.type_id) === 5"  :inputData="inputData" :selectedOptions="selectedOptions" @inputOptions="updateInputOptions"></checkbox-input>
            <date-input             v-if="Number(inputData.type_id) === 6"  :inputData="inputData" @inputValue="updateInputValue"></date-input>
            <file-input             v-if="Number(inputData.type_id) === 7"
                :inputData="inputData"
                @inputValue="updateInputValue"
                @addFileToForm="addFileToForm"
            ></file-input>
            <ssn-input              v-if="Number(inputData.type_id) === 8"  :inputData="inputData" @inputValue="updateInputValue"></ssn-input>
            <zip-input              v-if="Number(inputData.type_id) === 9"  :inputData="inputData" @inputValue="updateInputValue"></zip-input>
            <email-input            v-if="Number(inputData.type_id) === 10" :inputData="inputData" @inputValue="updateInputValue"></email-input>
            <phone-input            v-if="Number(inputData.type_id) === 11" :inputData="inputData" @inputValue="updateInputValue"></phone-input>
            <informative-text-input v-if="Number(inputData.type_id) === 12" :inputData="inputData" @inputValue="updateInputValue"></informative-text-input>
            <zip-en-input           v-if="Number(inputData.type_id) === 13" :inputData="inputData" @inputValue="updateInputValue"></zip-en-input>
            <citizenship-input      v-if="Number(inputData.type_id) === 14" :inputData="inputData" @inputValue="updateInputValue"></citizenship-input>
            <date-of-birth-input    v-if="Number(inputData.type_id) === 15" :inputData="inputData" @inputValue="updateInputValue"></date-of-birth-input>
            <citizenship-en-input   v-if="Number(inputData.type_id) === 16" :inputData="inputData" @inputValue="updateInputValue"></citizenship-en-input>
            <textarea-logic-input   v-if="Number(inputData.type_id) === 17" :inputData="inputData" @inputValue="updateInputValue"></textarea-logic-input>
        </div>
    </div>
</template>
<script>

import TextInput            from './inputs/Text.vue';
import TextAreaInput        from './inputs/TextArea.vue';
import NumberInput          from './inputs/Number.vue';
import DateInput            from './inputs/Date.vue';
import InformativeTextInput from './inputs/InformativeText.vue';
import FileInput            from './inputs/File.vue';
import SelectInput          from './inputs/Select.vue';
import CheckboxInput        from './inputs/Checkbox.vue';
import RadioInput           from './inputs/Radio.vue';
import SSNInput             from './inputs/SocialSecurityNumber.vue';
import ZipCodeInput         from './inputs/ZipCode.vue';
import EmailInput           from './inputs/Email.vue';
import PhoneInput           from './inputs/PhoneNumber.vue';
import ZipCodeEnInput       from './inputs/ZipCodeEn.vue';
import CitizenshipInput     from './inputs/Citizenship.vue';
import CitizenshipEnInput   from './inputs/CitizenshipEn.vue';
import DateOfBirthInput     from './inputs/DateOfBirth.vue';
import TextAreaLogic        from './inputs/TextAreaLogic.vue';

export default {
    props: ['inputgroup', 'selectedOptions'],
    emits: [
        'inputValue',
        'inputOptions',
        'addFileToForm',
    ],
    components: {
        'text-input'            : TextInput,
        'textarea-input'        : TextAreaInput,
        'textarea-logic-input'  : TextAreaLogic,
        'number-input'          : NumberInput,
        'date-input'            : DateInput,
        'informative-text-input': InformativeTextInput,
        'file-input'            : FileInput,
        'select-input'          : SelectInput,
        'checkbox-input'        : CheckboxInput,
        'radio-input'           : RadioInput,
        'ssn-input'             : SSNInput,
        'zip-input'             : ZipCodeInput,
        'email-input'           : EmailInput,
        'phone-input'           : PhoneInput,
        'zip-en-input'          : ZipCodeEnInput,
        'citizenship-input'     : CitizenshipInput,
        'citizenship-en-input'  : CitizenshipEnInput,
        'date-of-birth-input'   : DateOfBirthInput
    },
    data() {
        return {
            debug: false,
        }
    },
    mounted() {
        this.getUrlParams();
    },
    methods: {
        updateInputValue(inputId, value){
            this.$emit('inputValue', inputId, value);
        },
        updateInputOptions(options, selected){
            this.$emit('inputOptions', options, selected);
        },
        addFileToForm(inputId, fileIndex, file){
            this.$emit('addFileToForm', inputId, fileIndex, file);
        },
        getUrlParams(){
            const searchParams = new URLSearchParams(window.location.search);
            if(searchParams.has('debug') && searchParams.get('debug') == 'tibe'){
                console.log("active!");
                this.debug = true;
            }
        }
    },
    computed: {
        inputGroupClass(){
            let classString = "";

            if(this.inputgroup.inputs.length > 1){
                classString += "form__inputgroup-wrapper--visible";
            }

            if(this.debug){
                classString += " debug__applicationform-inputgroup";
            }
            return classString;
        }
    }
}
</script>